import { useCallback, useState } from 'react';
import { useModalContext } from '$quantum/atoms/Modal/useModalContext';
import { useResizeViewport } from '$util/hooks/useResizeViewport';
import { Button } from '@/components/atoms/Button';

interface HeaderCellProps {
  title: string;
  subtitle?: string;
  price?: string;
  ctaText?: string;
  ctaLink?: string;
  className?: string;
}

export function HeaderCell({
  title,
  ctaLink,
  ctaText,
  price,
  subtitle,
  className,
}: HeaderCellProps): JSX.Element {
  const [formattedPrice, setFormattedPrice] = useState(price);
  const { closeModal } = useModalContext();

  const formatPrice = useCallback(
    (isMobile: boolean) => {
      setFormattedPrice(isMobile ? price?.slice(0, -3) : price);
    },
    [price]
  );

  useResizeViewport({ breakpoint: 'sm', direction: 'down', fn: formatPrice });

  const handleCtaClick = () => {
    if (ctaLink) {
      // router.push(ctaLink, undefined, { shallow: true, scroll: true });
      closeModal();
    }
  };

  return (
    <div className={className}>
      <p className="header-cell-title">{title}</p>
      <p className="header-cell-price-wrapper">
        <p className="header-cell-subtitle">{subtitle}</p>
        <p className="header-cell-price">{formattedPrice}</p>
      </p>
      {ctaLink && (
        <Button size="XS" href={ctaLink} onClick={handleCtaClick}>
          {ctaText}
        </Button>
      )}
    </div>
  );
}
